<div class="modal-header">
  <h4 class="modal-title">Your session is about to expire</h4>
</div>
<div class="modal-body">
  <p>You will be logged out in <strong>{{displayTime}}</strong>.</p>
  <p>Click "Stay logged in" to extend your session and keep your work.</p>
  <div *ngIf="error" class="alert alert-danger">{{error}}</div>
</div>
<div class="modal-footer">
  <button type="button" bkButton color="secondary" (click)="onForceLogout()" [disabled]="extending">
    Log out
  </button>
  <button type="button" bkButton (click)="onStayLoggedIn()" [disabled]="extending">
    {{extending ? 'Extending...' : 'Stay logged in'}}
  </button>
</div>
